export const DOMAIN_SORTS = [
  {
    key: "domain_asc",
    label: "Domain, A-Z",
  },
  {
    key: "domain_desc",
    label: "Domain, Z-A",
  },
  {
    key: "created_at_desc",
    label: "Created At, Newest First",
  },
  {
    key: "created_at_asc",
    label: "Created At, Oldest First",
  },
] as const;

export type DomainSort = (typeof DOMAIN_SORTS)[number]["key"];

export const DOMAIN_FILTERS = [
  {
    key: "active",
    label: "Active",
  },
  {
    key: "archived",
    label: "Archived",
  },
] as const;

export type DomainFilter = (typeof DOMAIN_FILTERS)[number]["key"];
